module.exports = __webpack_public_path__ + "img/repositorio_unico_img3.a7d5d862.jpg";